export default __webpack_public_path__ + "static/explore-submenu-14b24d9bfbd6f2929a7132a19669140d.png";